import { CircularProgress } from "@mui/material";
import styles from "./SpinnerAnimation.module.scss";
interface SpinnerAnimationProps {
    isLoading?: boolean;
    className?: string;
}

export const SpinnerAnimation = ({ isLoading, className }: SpinnerAnimationProps) => (
    <div className={`${styles.spinnerContainer} ${className ?? ""}`}>
        <CircularProgress disableShrink className={`${isLoading ? "" : styles.hiddenSpinner}`} />
    </div>
);
